// import Vue from 'vue'
import { createWebHashHistory, createRouter } from "vue-router";

import Admin from '@/components/Admin'
import Superadmin from '@/components/Superadmin'
import Gamemaster from '@/components/Gamemaster'
import Player from '@/components/Player'
import Start from '@/components/Start'
import Drawing from '@/components/Drawing'

// Vue.use(VueRouter)

const routes = [
  {
    path: '/player',
    name: 'Player',
    component: Player,
    props: route => ({ query: route.query.token })
  },
  {
    path: '/gamemaster',
    name: 'Gamemaster',
    component: Gamemaster,
    props: route => ({ query: route.query.token })
  },
  {
    path: '/Admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/drawing',
    name: 'Drawing',
    component: Drawing
  },
  {
    path: '/',
    name: 'Start',
    component: Start
  },
  {
    path: '/Superadmin',
    name: 'Superadmin',
    component: Superadmin
  }
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router
